import { render } from "./ui-lightbox.vue?vue&type=template&id=5105c91e"
import script from "./ui-lightbox.vue?vue&type=script&lang=js"
export * from "./ui-lightbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__